import { CommonModule } from '@angular/common';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { LucideAngularModule } from 'lucide-angular';
import { Icons } from '../../../../shared/helpers/icons';
import { UserDataService } from '../../../../shared/services/userData.service';
import { ThreatService } from '../../../../shared/services/threat.service';
import { SpinnerComponent } from '../../../components/spinner/spinner.component';
import { NoEmojiDirective } from '../../../../shared/helpers/noEmoji.directive';

@Component({
  selector: 'new-threat',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    LucideAngularModule,
    NoEmojiDirective,
    SpinnerComponent
  ],
  templateUrl: './new-threat.component.html',
  styleUrl: './new-threat.component.css'
})
export class NewThreatComponent implements OnInit  {
  icons = Icons;
  currentBuildingId: string | null = null;
  loading: boolean = false;

  @Output() onClose = new EventEmitter<void>;
  @Output() onSave = new EventEmitter<any>;

  constructor(
    private userDataService: UserDataService,
    private threatService: ThreatService
  ) {}

  ngOnInit(): void {
    this.currentBuildingId = this.userDataService.getBuildingId();
  }

  threatForm = new FormGroup({
    threat: new FormControl('', Validators.required),
    probability: new FormControl('Highly likely'),  
    magnitude: new FormControl('Catastrophic'),
    warning: new FormControl('Minimal'),
    duration: new FormControl('12+ hrs'),
    risk_priority: new FormControl('High')
  })

  closeModal(): void {
    this.onClose.emit();
  }

  saveNew(): void {
    if (this.threatForm.valid && this.currentBuildingId) {
      this.loading = true;
      const threatPayload = this.threatForm.value;
      this.threatService.createNewThreat(this.currentBuildingId, threatPayload).subscribe({
        next: (response) => {
          this.loading = false;
          if (response.has_error) {
            this.loading = false;
            this.onSave.emit({ type: 'unsuccess', message: response.message });
          } else {
            this.onSave.emit({ type: 'success', message: 'This occurred after creating a new threat.' });
          }
        },
        error: (error) => {
          this.loading = false;
          this.onSave.emit({ type: 'unsuccess', message: error.message });
        }
      })
    } else {
      console.log('Form is invalid', this.threatForm.value);
      alert("You're missing some required fields.")
    }
  }
}
